/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleStepBack, setHasBeenRepaired, setRepairStepValid, submitGlassClaim } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import './Glass.css';
import GlassRepairsNo from './GlassRepairsNo';
import GlassRepairsYes from './GlassRepairsYes';
import { showRepairsPleaseNote } from '../../../actions/modalActions';

var lat = 0
var lng = 0

class GlassRepairs extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            adressSelect: this.props.claimSubmit.adress,
            lat: this.props.claimSubmit.addressLat,
            lng: this.props.claimSubmit.addressLon,
            isRepaired: undefined,
            optionValue: "",
            isInstalled: ""
        };
        this.handleIsRepaired = this.handleIsRepaired.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    } 

    async handleStepBack() {
        this.props.dispatchHandleStepBack();
    }

    async handleSubmit() {
        if (this.state.isRepaired) {
            await this.props.dispatchSubmitGlass();
        }
        else {
            this.props.dispatchShowGlassRepairsPleaseNote();
        }
    }

    handleIsRepaired(isRepaired) {
        this.setState({ isRepaired: isRepaired, optionValue: "" });
        this.props.dispatchSetHasBeenRepaired(isRepaired)
        this.props.dispatchSetRepairStepValid(false);
    }

    async handleOnChange(e) {
        this.setState({ optionValue: e.target.value });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        return (<div className="col ssp-container-fnol-repairs ssp-container-fnol-step-header-padding">
            <div className="row noma">
                <div className="col-12 nopa ssp-header-fnol-repairs">
                    <div className="row noma">
                        <div className="fnol-step-header-icon-area">
                            <img src='/my-policy/Images/Claims/Numbers/number-4-red-32x32px.svg' alt="Step 4" title="Step 4" />
                        </div>
                        <div className="col fnol-step-header-title-area">
                            <h3>Repairs/<br className="glassclaims-newline" />Replacement</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row noma">
                <div className="col-12 fnol-steps-info-section-holder">
                    <hr className="hr-minus21px" />
                    <div className="row noma glassclaims-parent-row">
                        <div className="col nopa">
                            <p className="text-16 glassclaims-intro-p"><b>Have you already repaired/<br className="glassclaims-newline" />replaced the damage</b></p>
                        </div>
                        <div className="nopa text-lg-right glassclaims-button-col">
                            <div className="row noma glassclaims-button-row">
                                <div className="col nopa glassclaims-button-no">
                                    <button className={!this.state.isRepaired && this.state.isRepaired !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsRepaired(false)}>No</button>
                                </div>
                                <div className="glassclaims-mobile-gutter nopa"></div>
                                <div className="col nopa glassclaims-button-yes">
                                    <button className={this.state.isRepaired && this.state.isRepaired !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsRepaired(true)}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-0px mt-20px glassclaims-hr-2px" />
                    {/* Yes journey*/}

                    {this.state.isRepaired && this.state.isRepaired !== undefined &&
                        <GlassRepairsYes />
                    }
                    {!this.state.isRepaired && this.state.isRepaired !== undefined &&

                    <GlassRepairsNo />
                    }

                    <div className="nopa fnol-steps-buttonholder mt-40px">
                        <button className="btn btn-solid-red fnol-buttonreverse-button-next glassclaims-button-next" onClick={this.handleSubmit} disabled={!this.props.claimSubmit.repairStepValid }>Next</button>
                        <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleStepBack}>Back</button>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowGlassRepairsPleaseNote: () => dispatch(showRepairsPleaseNote()),
        dispatchSetHasBeenRepaired: (value) => dispatch(setHasBeenRepaired(value)),
        dispatchSubmitGlass: () => dispatch(submitGlassClaim()),
        dispatchSetRepairStepValid: (value) => dispatch(setRepairStepValid(value)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GlassRepairs)
